export default "__VITE_ASSET__b50ed484__"